export default __webpack_public_path__ + "static/media/DSZ Price Shipping Fee Review_21082025.254dcf27.zip";